module.exports = __webpack_public_path__ + "static/media/item__food-6.9365896e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-6.png
// module id = 2331
// module chunks = 0